type DesignLike = object;

export const toPlainValue = <T>(value: T | { toJSON: () => T }): T => {
    return value && typeof (value as { toJSON?: () => T }).toJSON === 'function' ? (value as { toJSON: () => T }).toJSON() : (value as T);
};

export const getDesignValue = <T>(design: DesignLike, key: string): T | undefined =>
    (design as { get: (attribute: string) => unknown }).get(key) as T | undefined;

export const getDesignCollection = <T>(design: DesignLike, key: string): T[] => {
    const value = getDesignValue<T[] | { toJSON: () => T[] }>(design, key);
    if (!value) return [];

    const plainValue = toPlainValue(value);
    return Array.isArray(plainValue) ? plainValue : [];
};
